import { Theme } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { COLORS } from '../../styles/theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    text: {
      fontFamily: 'OpenSans, sans-serif',
      color: COLORS.MARINE,
      fontSize: 12,
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalContainer: {
      display: 'flex',
      flexDirection: 'column',
      position: 'fixed',
      minWidth: '30%',
      maxWidth: '50%',
      backgroundColor: '#ffffff',
      borderRadius: '5px',
      padding: '2rem',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.5)',
    },
  }),
);

export default useStyles;
